<template>
    <div class="container position-relative">
        
  </div>
</template>

<script>
import { generateUUID } from '~/plugins/grapesjs/helper';
export default {
    name:"modal_resources",
    icons:{
        
    },
    components:{

    },
    data() {
        return {
        }
    },
    props:{
    },
    methods:{
        
    }
}
</script>

<style lang="scss">
</style>